import { useEffect, useState } from 'react';

const CREATE_KEY = 'offline_invoice';
const EDIT_KEY_PREFIX = 'offline_invoice_edit_';

const useOfflineInvoice = (invoiceId = null) => {
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const storageKey = invoiceId ? `${EDIT_KEY_PREFIX}${invoiceId}` : CREATE_KEY;

	useEffect(() => {
		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);
		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);
		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	const saveInvoice = (data) => {
		try {
			localStorage.setItem(storageKey, JSON.stringify(data));
		} catch (e) {}
	};

	const getInvoice = () => {
		try {
			const data = localStorage.getItem(storageKey);
			return data ? JSON.parse(data) : null;
		} catch (e) {
			return null;
		}
	};

	const deleteInvoice = () => {
		localStorage.removeItem(storageKey);
	};

	const isSameAsOriginal = (current, original) => {
		if (!original) return false;
		return JSON.stringify(current) === JSON.stringify(original);
	};

	return {
		saveInvoice,
		getInvoice,
		deleteInvoice,
		isOnline,
		isSameAsOriginal,
	};
};

export default useOfflineInvoice;
